const designerBlocks = document.querySelectorAll('.designer-details');
const popUpBoxes = document.querySelectorAll('.designer-popup-box .modal');
designerBlocks.forEach(function (designerBlock) {
	designerBlock.addEventListener('click', function (eve) {
		popUpBoxes.forEach(function (popUpBox) {
			if (designerBlock.id == popUpBox.id) {
				popUpBox.style.display = 'block';
				popUpBox.style.opacity = 1;
				popUpBox.style.background = "rgba(0,0,0,0.3)"
				document.body.style.overflowY = "hidden";
			}
		})
	})
});
const popUpBoxes1 = document.querySelectorAll('.designer-popup-box .modal');
popUpBoxes1.forEach(function (popUpBox) {
	document.addEventListener('click', function (e) {
		if (e.target === popUpBox) {
			if (popUpBox.style.display = "block") {
				popUpBox.style.display = "none";
				popUpBox.style.background = "unset";
				document.body.style.overflowY = "unset";
			}
		}
	})
})
//Function for Arrows
const ltArr = document.querySelector('.about-designer .arrowLt');
const rtArr = document.querySelector('.about-designer .arrowRt');
//Parent container contains arrows buttons
let testDiv = document.querySelector('.abt-designer-container');
let initialContent = testDiv.innerHTML;
const checkChangesInterval = setInterval(() => {
	const currentContent = testDiv.innerHTML;
if (currentContent !== initialContent) {
	let arr = document.querySelectorAll('.abt-designer-container button');
		arr.forEach(function (btn) {
			if (btn.classList.contains('previous')) {
				btn.replaceChild(ltArr, btn.querySelector('svg'));
				ltArr.style.display = "block";
				ltArr.style.color = "#000000";
			} else if (btn.classList.contains('next')) {
				btn.replaceChild(rtArr, btn.querySelector('svg'));
				rtArr.style.display = "block";
				rtArr.style.color = "#000000";
			}
		})
initialContent = currentContent;
// if above condtion is true then stop interval
  clearInterval(checkChangesInterval);
}

}
, 1000);
